import {
  IonAccordion,
  IonButton,
  IonCol,
  IonGrid,
  IonItem,
  IonRow,
  IonText,
} from "@ionic/react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { v4 } from "uuid";
import { makePOSTRequest } from "../request/rawRequest";
import { Skill } from "./FormalPratique/FormalPratique";

interface Theme {
  _id: string;
  name: string;
  pictureUrl: string;
  quizz?: any;
  synthesis?: any;
  corrected?: string;
}

interface Props {
  skill: Skill;
}

const AccordionLoaderTheme: React.FC<Props> = ({ skill }) => {
  const [themes, setThemes] = useState<Theme[]>([]);
  const subText = skill.name.match(/ \(.*\)/)?.[0] ?? "";

  return (
    <IonAccordion
      onClick={() => {
        if (themes.length <= 0) {
          const themesPromises = skill.themeIDs.map((_id) =>
            makePOSTRequest("/themes", { _id })
          );

          Promise.all(themesPromises)
            .then((res) => [...res.map((theme) => theme[0])])
            .then((themes) => themes.filter((theme) => theme !== undefined))
            .then((themes) => {
              return themes.map((theme) => ({
                _id: theme._id,
                name: theme.name,
                pictureUrl: theme.picture_url ?? "",
                quizz: theme.quizz,
                synthesis: theme.synthesis,
                corrected: theme.corrected,
              }));
            })
            .then((themes: Theme[]) => {
              setThemes(themes);
            });
        }
      }}
    >
      <IonItem slot="header">
        <span
          className="firstLetterUpper"
          style={{
            textTransform: "lowercase",
            fontWeight: "bold",
            color: " var(--ion-color-secondary)",
          }}
        >
          <span
            style={{
              letterSpacing: 2,
            }}
          >
            {skill.name.replace(subText, "")}
          </span>{" "}
          {subText}
        </span>
      </IonItem>
      <div slot="content">
        {themes.length <= 0 ? (
          "Chargement"
        ) : (
          <>
            {themes.map((theme) => (
              <Link
                to={"/formalPratique/" + skill._id + "/" + theme._id}
                key={v4()}
              >
                <IonGrid>
                  <IonRow>
                    <IonCol size-lg="3">
                      <img
                        className="max-height-100 fit-img border-radius border-secondary"
                        src={
                          theme.pictureUrl.length > 0
                            ? theme.pictureUrl
                            : "https://t4.ftcdn.net/jpg/00/89/55/15/240_F_89551596_LdHAZRwz3i4EM4J0NHNHy2hEUYDfXc0j.jpg"
                        }
                      ></img>
                    </IonCol>
                    <IonCol
                      className="flex ion-align-items-center firstLetterUpper"
                      style={{ fontWeight: "bold" }}
                    >
                      <IonText color="dark">{theme.name}</IonText>
                    </IonCol>
                  </IonRow>
                </IonGrid>
              </Link>
            ))}
            {skill.quizz && (
              <div className="ion-justify-content-center flex">
                <IonButton
                  color="secondary"
                  onClick={() => {
                    window.location.href = "formalPratique/" + skill._id;
                  }}
                >
                  Accès au quiz
                </IonButton>
              </div>
            )}
          </>
        )}
      </div>
    </IonAccordion>
  );
};

export default AccordionLoaderTheme;
